"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const appStateSelectAppId_1 = __importDefault(require("./appStateSelectAppId"));
const appStateSelectFirebaseRealtimeDatabaseCache_1 = __importDefault(require("./appStateSelectFirebaseRealtimeDatabaseCache"));
const appStateBuildMiddlewareFirebaseRealtimeDbCache = (localStorate) => (store) => (next) => (action) => {
    const dbCacheBefore = (0, appStateSelectFirebaseRealtimeDatabaseCache_1.default)(store.getState());
    const nextAction = next(action);
    const stateAfter = store.getState();
    const dbCacheAfter = (0, appStateSelectFirebaseRealtimeDatabaseCache_1.default)(stateAfter);
    const appId = (0, appStateSelectAppId_1.default)(stateAfter);
    if (dbCacheBefore !== dbCacheAfter) {
        if (!dbCacheBefore) {
            localStorate.removeItem(`dbCache:${appId}`);
        }
        else {
            localStorate.setItem(`dbCache:${appId}`, JSON.stringify(dbCacheAfter));
        }
    }
    return nextAction;
};
exports.default = appStateBuildMiddlewareFirebaseRealtimeDbCache;
